
/* eslint-disable import/no-dynamic-require */
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
  @Prop({ required: true })
  language!: string;

  // eslint-disable-next-line global-require
  text = require(`@/text_${this.language}.json`);

  elem = document.documentElement;

  // eslint-disable-next-line class-methods-use-this
  closeFullscreen():void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  fullScreenSupport():boolean {
    return document.fullscreenEnabled;
  }

  openFullscreen():void {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    }
  }

  toggleFullscreen():void {
    if (!document.fullscreenElement) {
      this.openFullscreen();
    } else {
      this.closeFullscreen();
    }
  }
}
